import React from 'react';
import { ScrollArea } from '@radix-ui/themes';


import type { MediaMetricLog } from '@/database/types';

interface MediaChartProps {
  data: Array<MediaMetricLog>;
}

export default function MediaChart({ data }: MediaChartProps) {
  return (
    <ScrollArea>
      <div className="Text">Tags</div>
      {data.map((log) => (
        <div className="Tag" key={log.id}>
          {log.textValue}
        </div>
      ))}
    </ScrollArea>

    // <ScrollArea.Root className="ScrollAreaRoot">
    //   <ScrollArea.Viewport className="ScrollAreaViewport">
    //     <div style={{ padding: '15px 20px' }}>
    //       <div className="Text">Tags</div>
    //       {data.map((log) => (
    //         <div className="Tag" key={log.id}>
    //           {log.textValue}
    //         </div>
    //       ))}
    //     </div>
    //   </ScrollArea.Viewport>
    //   <ScrollArea.Scrollbar
    //     className="ScrollAreaScrollbar"
    //     orientation="horizontal"
    //   >
    //     <ScrollArea.Thumb className="ScrollAreaThumb" />
    //   </ScrollArea.Scrollbar>
    //   <ScrollArea.Corner className="ScrollAreaCorner" />
    // </ScrollArea.Root>

    // <Card
    //   size="2"
    //   style={{
    //     aspectRatio: '1 / 1',
    //     width: '100%',
    //     maxHeight: '300px',
    //     display: 'flex',
    //     flexDirection: 'column',
    //   }}
    // >
    //   <Flex align="center" gap="2" mb="3">
    //     <Flex align="center" justify="center" className="text-current">
    //       <DynamicIcon name={metric?.icon} />
    //     </Flex>
    //     <Text as="div" size="3" weight="bold" trim="normal">
    //       {metric.name ?? 'Name'}
    //     </Text>
    //   </Flex>

    //   <Inset
    //     clip="padding-box"
    //     side="bottom"
    //     pb="0"
    //     style={{ flex: 1, minHeight: 0 }}
    //   >
    //     {metric.type === 'media' ? (
    //       <MetricChart data={metric.entries} chartType={metric.chartType} />
    //     ) : (
    //       <MediaChart data={metric.entries} chartType={metric.chartType} />
    //     )}
    //   </Inset>
    // </Card>
  );
}
